var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVamoosMore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "28px",
    viewBox: "0 0 29 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "vamoos-more") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vamoos-more",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5,27.5 C21.95584,27.5 28,21.45584 28,14 C28,6.544156 21.95584,0.5 14.5,0.5 C7.044156,0.5 1,6.544156 1,14 C1,21.45584 7.044156,27.5 14.5,27.5 Z",
    id: "Stroke-1",
    stroke: "#ED8532"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.010498,
    y1: 14.0048209,
    x2: 21.010288,
    y2: 13.9999991,
    id: "Stroke-3",
    stroke: "#ED8532"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-5",
    stroke: "#ED8532",
    points: "15.98199 8.0191 21.01028 13.999996 15.98199 19.99054"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVamoosMore);
export default __webpack_public_path__ + "static/media/vamoos-more.98a44a7d4d47ef0f3fa55ac95e318aec.svg";
export { ForwardRef as ReactComponent };